export const about_list = [
	"Registered",
	"Regulated",
	"Experienced Team",
	"24/7 Support",
];